module.exports = __webpack_public_path__ + "static/img/19.316ad973.png";